

window.LookSKY = { version: '1.0.0' };
window.LS = window.LookSKY;




;(function (LS) {
/**
 * 生成唯一UUID值
 */
LS.getUUID = function (len) {
    len = len || 16;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * len | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(len);
    });
};

/**
 * 挂载到LS
 */
LS.setData = function (key, val) {
    LS[key] = val;
}

/**
 * 获取LS上字段
 */
LS.getData = function (key) {
    return LS[key] || '';
}

/**
 * 时间日期格式化
 * 用法 formatTime(new Date(), 'yyyy-MM-dd hh:mm:ss')
 * @param  time
 * @param  fmt
 */
LS.formatTime = function(time, fmt = 'yyyy-MM-dd hh:mm:ss') {
    time = parseInt(time);
    if (!time) {
      return '';
    }
    const date = new Date(time);
    let o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        );
      }
    }
    return fmt;
  }

})(LookSKY);

// cookie操作
;(function (LS) {
  /**
   * cookie类,cookie类可以让开发很轻松得控制cookie，我们可以随意增加修改和删除cookie，也可以轻易设置cookie的path, domain, expire等信息
   * @namespace LS.cookie
   */
  LS.cookie = {
    /**
     * 设置一个cookie
     * 简单得说，子域可以获取根域下的cookie, 但是根域无法获取子域下的cookie.
     * @param {String} name cookie名称
     * @param {String} value cookie值
     * @param {Number} hour 存活时间，单位:小时
     * @param {String} domain 所在域名
     * @param {String} path 所在路径
     * @return {Boolean} 是否成功
     * @example
     *  LS.cookie.set('looksky', value, 24, "www.looksky.com", "/product");
     */
    set : function(name, value, hour, domain, path) {
      if (hour) {
        var expire = new Date();
        expire.setTime(expire.getTime() + 3600000 * hour);
      }
      document.cookie = 
		  name + "=" + encodeURIComponent(value) + "; " + 
		  (expire ? ("expires=" + expire.toGMTString() + ";") : "") + 
		  "domain=" + ( domain || location.hostname ) + ";"+
		  "path=" + (path||'/') + ";";
    },

    /**
     * 获取指定名称的cookie值
     *
     * @param {String} name cookie名称
     * @return {String} 获取到的cookie值
     * @example
     *    LS.cookie.get('name'); //获取cookie
     */
    get : function(name) {
        var a = document.cookie.match(RegExp("(^|;\\s*)"+name+"=([^;]*)(;|$)")) || [];
        return decodeURIComponent(a[2] || '');
    },

    /**
     * 删除指定cookie,复写为过期
     *
     * @param {String} name cookie名称
     * @param {String} domain 所在域
     * @param {String} path 所在路径
     * @example
     *    LS.cookie.del('value1'); //删除cookie
     */
    del : function(name, domain, path) {
      document.cookie = name + "=; expires=Mon, 26 Jul 1997 05:00:00 GMT;" + "max-age=0;" + (path ? ("path=" + path + "; ") : "path=/; ") + "domain="+( domain || location.hostname )+";";
    }
  };

})(LookSKY);





;(function (LS) {
/**
 * 环境判断
 */
var env = 'production'; // 默认生产环境
if (location.hostname.match(/localhost|127\.0\./i)) {
  env = 'local';
} else if (LS.cookie.get('looksky_env') == 'test') { 
  env = 'test';
} else if (LS.cookie.get('preview_theme') == 1) {
  env = 'preview';
} else if (/\bdebug=1\b/.test(location.search)) { // 须放最后，任何环境都可以支持debug模式，输出信息到控制台
  env = 'debug';
}

LS.env = env;

/**
 * 平台判断
 */
var isMobile = !!navigator.userAgent.match(/Android|iPhone|iPad|iPod/i); 
var platform = isMobile ? 'H5' : 'PC';
LS.platform = platform;

})(LookSKY);



;(function(LS) {
  
  LS.reportJSError = function(msg, url, line) {
    if (LS.env == 'production') {
      LS.stat({ eid: "js_error", ext1: msg || 'unknow', ext2: url || '', ext3: (line || 0) + '' });
    } else {
      console.error(msg, url, line);
    }
  };

  //非生产环境不上报
  if (LS.env != 'production') {
    window.onerror = null;
    document.removeEventListener("error", window.loadErrHandler || function() {});
    return;
  }

  !window.onerror && (window.onerror = function(msg, url, line){
    try {
      var stack = '', ca = arguments.callee.caller;
      if (ca) {
        var b, e = [];
        while (ca) {
          b = ca;
          e.push(b.toString().replace(/[\t\n\r]/g, "").substring(0, 100) + '...');
          ca = ca.caller;
        }
        stack='; 堆栈：'+e.join(" --> ");
      }
      msg += stack.substring(0, 600);
    } catch (e) { };

    LS.stat({ eid: "js_error", ext1: msg, ext2: url, ext3: (line || 0) + '' });
    return true;
  });

  !window.loadErrHandler && document.addEventListener("error", function (e) {
    var elem = e.target || e.srcElement;
      url = elem.getAttribute('src') || elem.getAttribute('href') || '';
    if (elem.tagName.toLowerCase() == 'img') {
      if (elem.getAttribute('data-reload') != 1) {
        elem.setAttribute('data-reload', '1');
        elem.src = url;
      } else if (elem.getAttribute('data-reload') == 1 && elem.getAttribute('data-error') != 1) {
        elem.setAttribute('data-error', '1');
        elem.src = 'https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ls_lazy_loading_img.png?v=1653549191';
      }
    }
    !!url && LS.stat({ eid: "load_error", ext1: '', ext2: url, ext3: 'report_error.38' });
  }, true);
  
})(LookSKY);

/**
 * 
 * @param {string} 
 * @return 
 * @return 
 * @date 
 * @author 
 * 
 */


//ver 1.2 2014-03-10
;
(function() {
    function AQ_SECAPI_CheckXss() {
        var Url = decodeURI(location.href);
        var Refer = decodeURI(document.referrer);
        var XssPattern = new RegExp("['\"<>`]|script:");
        if (XssPattern.test(Url) || XssPattern.test(Refer)) {
            var send = new Image();
            send.onload = send.onerror = function() {
                send = null;
            };
            send.src = location.protocol + "//cdnlog.zhenai.com/web_monitor?dtype=error&msg=xss&file=" + encodeURIComponent(location.href) + "&line=0";

            setTimeout(function() {
                location.href = Url.replace(/['\"<>`]|script:/gi, '');
            }, 200);
        }
    }

    try {
        AQ_SECAPI_CheckXss();
    } catch (e) {

    }

})();
;(function (LS) {

    function toString(value) {
    return value == null ? '' : value+'';
    }

    /**
     * 转义
     * @method encodeHTML
     * @desc  在String原型上扩展了方法encodeHTML 对字符串进行HTML编码  即:把<>"'/\变成&#xx格式
     * @example 
        var str='<"';
        str.encodeHTML();
        alert(str);
    */
    function encodeHTML(str) {
        var rtstr='';
        for (var i=0; i<str.length; i++) {
            if (/\W/.test(str[i]) && str.charCodeAt(i)<256) {
                rtstr+='&#'+str.charCodeAt(i)+';'
            }else {
                rtstr+=str[i]
            }
        }
        return rtstr;
    }

    /**
     * 转义
     * @method decodeHTML
     * @desc  在String原型上扩展了方法decodeHTML 对字符串进行HTML解码  即:把&#xx格式变成<>"'/\
     * @example 
        var str='&#68';
        str.decodeHTML();
        alert(str);
    */
    function decodeHTML(str) {
        return toString(str).replace(/&amp;/g,"&#38;")
                    .replace(/&lt;/g,"&#60;")
                    .replace(/&gt;/g,"&#62;")
                    .replace(/&quot;/g,"&#34;")
                    .replace(/&apos;/g,"&#39;")
                    .replace(/&nbsp;/g,"&#160;")
                    .replace(/&#(\d+);?/g, function(a,b){return String.fromCharCode(b)})
                    .replace(/&#x([0-9a-f]+);?/ig, function(a,b){return String.fromCharCode(parseInt(b, 16))});
    }


    LS.encodeHTML = encodeHTML;
    LS.decodeHTML = decodeHTML;


})(LookSKY);

;(function (LS) {
    /**
     * 获取url参数 (不包括hash)
     * @method  getParam
     * @param {string} name 需要获取的url参数名
     * @param {string} url  需要解析的url
     * @return decodeuri之后的参数值
     * @desc 注意: 业务代码从url获取参数后, 务必进行严格的格式和类型校验, 避免xss攻击
     */
    LS.getParam=function(name,url) {
        var u=(url||location.href).split('#')[0];//去掉hash
        var r=new RegExp("(\\?|&)"+name+"=(.*?)(#|&|$)","i");
        var m=u.match(r);
        return decodeURIComponent(m ? m[2] : '');
    }

    /**
     * 删除url参数
     * @method delParam
     * @param {string} name 需要删除的url参数名
     * @param {string} url  需要解析的url
     * @return 删除之后的url
     */
    LS.delParam = function(name, url){
        var r=new RegExp("(\\?|#|&)("+name+"=.*?)(#|&|$)");
        url=url||location.href;
        var m=url.match(r);
        if(m && (m.length >= 3) && m[2]){
            var matchstr = m[0],
                s = m[2];
            if( matchstr.charAt(0) == '&' ){
                s = '&' + s;
            }
            return url.replace(s, '');
        }else{
            return url;
        }
    }

    /**
     * 添加url参数
     * @method addParam
     * @param {object|string} obj  需要添加的参数 可以是对象 也可以是字符串
     * @param {string} url 需要操作的url
     * @return 添加url参数之后的url
     */
    LS.addParam = function(obj, url){

        url=url||location.href;
        if (typeof obj != 'object' && !obj) {
            return url;
        }

        var p = obj;
        if (typeof obj == 'object') {
            p=[];
            for(var i in obj){
                p.push( encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]) );
            }
            p = p.join('&');
        }

        if( !/\?/.test(url) && !/#/.test(url) ){
            url = url + '?'+ p;
        }else if( /\?/.test(url) && !/#/.test(url) ){
            url = url + '&'+ p;
        }else if( !/\?/.test(url) && /#/.test(url) ){
            url = url.replace('#', '?'+ p +'#');
        }else{
            url = url.replace('?', '?'+ p +'&');
        }
        return url;
    };

})(LookSKY);


;(function (LS) {
  /**
   * 站点相关信息
   */
  var html = document.getElementsByTagName('html')[0];
  var rootUrl = html.getAttribute('root_url') || '';
  var currency;
  if (LS.cookie.get('cart_currency')) {
    currency = LS.cookie.get('cart_currency');
  } else {
    currency = html.getAttribute('currency') || 'USD';
  }

  var country = html.getAttribute('country') || 'US';
  if (country === 'en' || country === 'EN') {
    country = LS.cookie.get('localization');
  }

  LS.site = LS.site || {};
  LS.site.page = html.getAttribute('page') || 'other';
  LS.site.lang = (html.getAttribute('lang') || 'en');
  LS.site.country = country;
  LS.site.currency = currency;
  LS.site.symbol = html.getAttribute('symbol') || '$';
  LS.site.shop = html.getAttribute('shop') || '';
  LS.site.dir = rootUrl && rootUrl !== '/' ? rootUrl : '';
  LS.site.baseUrl = location.origin + LS.site.dir;
  LS.site.brand = html.getAttribute('brand') || 'LookSKY';
  LS.site.rate = typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate ? Shopify.currency.rate : '1.0';
  
})(LookSKY);
  
  
/**
 * 国际化
 * @namespace LS.i18n
 * @namespace LS.$t
 * 对locals配置文件取值并做解析: $t
 * 处理不同国家相应的金额展示: fmtAmount
 * 处理不同国家相应的时间展示: fmtTime
 */
;(function(LS) {
  var country = LS.site.country.toLowerCase();
  // 欧洲地区
  var EuropeArea = {
    'de': 'de', // 德语
    'fr': 'fr', // 法语
    'it': 'it', // 意大利语
    'es': 'es', // 西班牙语
    'pt': 'pt' // 葡萄牙语
  }

  var publicJson = JSON.parse($(".public-language-json").text() || 'null') || {};
  var pageJson = JSON.parse($(".page-language-json").text() || 'null') || {};
  /**
   * 
   * @param {string} key key值
   * @param {object} params 数据，不传默认纯文本处理
   * @returns 文案
   */
  function $t(key, params) {
    var valTmpl = pageJson[key] || publicJson[key] || '';
    if (params) {
      var tmpl = LS.tmpl(valTmpl, params);
      return tmpl;
    }  
    return valTmpl;
  }

  /**
   *
   * 根据国家格式化价格
   * 欧洲地区金额 . 需改为 , 例如：88.00 => 88,00 
   * @param {number string} amount 
   * @returns
   */
   function fmtAmount(amount, targetCountry) {
    targetCountry = targetCountry ? targetCountry.toLowerCase() : country;
    if (!amount) return '';
    if (!EuropeArea[targetCountry]) return amount;
    amount = amount + '';
    return amount.replace(/\./g, ',');   
  }

  /**
   * 根据国家格式化时间，意大利语为日/月/年外，其他语种均为月/日/年
   * @param {timestamp} time 
   * @returns 
   */
  function fmtTime(time) {
    if (!time) return '';
    if (EuropeArea[country] === EuropeArea['it']) return LS.formatTime(time, 'dd/MM/yyyy');
    return LS.formatTime(time, 'MM/dd/yyyy');
  }

  /**
   * 判断是否是欧洲国家
   * @param {string} country 
   * @returns 
   */
  function belongToEuropeArea(country) {
    country = country ? country.toLowerCase() : ''; 
    return !!EuropeArea[country];
  }

  /**
   * UTF-8 是一种针对Unicode的可变长度字符编码，可以表示Unicode标准中的任何字符，且其编码中的第一个字节仍与ASCII相容，使用一至四个字节为每个字符编码
   * @param {string} str 文本
   * @param {string} charset UTF-8、UTF-16
   * @returns 
   */
  function calcStrSize(str, charset) {
		let total = 0;
		charset = charset ? charset.toLowerCase() : '';
		for (i = 0; i < str.length; i++) {
			let charCode = str.charCodeAt(i);
			if (charset === 'utf-16' || charset === 'utf16') {
				total += charCode <= 0xffff ? 2 : 4;
			} else {
				if (charCode <= 0x007f) {
					total += 1;
				} else if (charCode <= 0x07ff) {
					total += 2;
				} else if (charCode <= 0xffff) {
					total += 3;
				} else {
					total += 4;
				}
			}
		}
		return total/1024;
	}

  LS.i18n = {
    $t: $t,
    fmtAmount: fmtAmount,
    fmtTime: fmtTime,
    calcStrSize: calcStrSize,
    belongToEuropeArea: belongToEuropeArea,
  }

  LS.$t = $t;

})(LookSKY);
/**
 * Hybride jsbridge接口
 * @namespace  LS.client
 * web调app统一接口: LS.client.invoke
 * web监听客户端事件统一接口: LS.client.on
 * app调web统一接口: window.LSJsBridge
 */
(function (LS) {
		var mapEvents = {},			// 事件对象映射集合
			mapFunctions = {};	// 方法对象映射集合
		var brand = LS.site.brand;
       var clientOrigin =  'lsjsbridge://' + brand.toLowerCase() + '.com';
			 var ua = navigator.userAgent;

        // 设置客户端协议
       function setClientOrigin (origin) {
            clientOrigin  = origin;
       }

		/**
		 * web调app统一接口
		 * @param {String} namespace 命名空间
		 * @param {String} method 方法名称
		 * @param {Object} params 参数
		 * @param {Function} callback 回调函数
		 * @returns
		 */
		function invoke(namespace, method, params, callback) {
			if (!namespace || !method) {
				alert("namespace和method不能为空");
				return;
			}

			//处理有回调的情况
			if (callback) {
				var cn = namespace + "." + method + (Math.random() + '').replace('0.', '');
				params = params || {};
				params.__callbackName = cn;
				mapFunctions[cn] = callback;
			}
      
      var hostname = location.hostname.split('.').slice(-2).join('.');
			var url =  clientOrigin
				+ '/'
				+ encodeURIComponent(namespace)
				+ '/'
				+ encodeURIComponent(method)
				+ ('?r=' + Math.random())
				+ (typeof params === "object" ? '&p=' + encodeURIComponent(JSON.stringify(params)) : '');

			// 后续需要考虑客户端外打开，未安装需拉起下载
			location.href = url;
			// console.log(url);
		};

		/**
		 * web监听app事件
		 * @param {String} eventName 事件名称
		 * @param {Function} callback 回调函数
		 */
		function on(eventName, callback) {
			if (!mapEvents[eventName]) {
				mapEvents[eventName] = [];
			}
			mapEvents[eventName].push(callback);
		};

		/**
		 * 卸载事件
		 * @param {String} eventName 事件名称
		 */
		function off(eventName) {
			if (mapEvents[eventName]) {
				delete mapEvents[eventName];
			}
		}


		/**
		 * app调web统一接口
		 * @param {String} handler 方法名
		 * @param {Object} params 参数
		 * @param {Function} callback 回调函数
		 * @returns
		 */
		window.LSJsBridge = function (handler, params) {
			if (/^event\./.test(handler)) { // 执行事件绑定函数队列中的所有函数
				var funcs = mapEvents[handler] || [];
				for (var i = 0; i < funcs.length; i++) {
					typeof funcs[i] === 'function' && funcs[i](params);
				}
			} else {
				if (typeof mapFunctions[handler] === "function") {
					setTimeout(function () {
						mapFunctions[handler](params);
						delete mapFunctions[handler];// 执行完销毁
					}, 0);
				}
			}
			// app主动调用待定：window.LSJsBridge('namespace.method', {callbackkey : 'callback123'});
		};


    function getName() {
      var name = ua.match(brand) ? brand : 'other';
      return name;
    }

    
    function getType() {
      var type = 'Web',       // LookSKY Web
          name = getName();
      if (name == brand) {
        if (ua.match(/Android/i)) {
          type = 'Android';  // LookSKY Android App
        } else if (ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i)) {
          type = 'iOS';     // LookSKY iOS App
        }
      }
      return type;
    }


		var isAndroid = ua.match(/Android/i);
		var isIOS = ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);
		
    LS.client = {
      name: getName(),
      type: getType(),
		  invoke: invoke,
		  on: on,
      setClientOrigin: setClientOrigin,
      isAndroid: isAndroid,
      isIOS: isIOS,
    };

})(LookSKY);


;(function (LS) {
	var prefix = LS.site.brand.toLowerCase();
/**
 * 生成uid并保存在cookie中
 * @method  getUid
 * @return {string} uid
 */
function getUid() {
  // 登录用户使用用户ID，未登录使用uuid
  var uid = LS.cookie.get('looksky-uuid');
  if (!uid) {
    uid = LS.getUUID();
    LS.cookie.set('looksky-uuid', uid, 24 * 365); // 1年有效期
  }
  
  return uid;
}

// sessionId 每次会话结束后清除
function getSid() {
  var sid = LS.cookie.get('looksky-sid');
  if (!sid) {
    sid = LS.getUUID();
    LS.cookie.set('looksky-sid', sid);
  }
  
  return sid;
}


function logIn() {

}


function logOut() {


}

function getInfo() {

  return {
    id: LS.cookie.get(prefix + '_userid') || '',
    token: LS.cookie.get(prefix + '_token') || '',
    country: LS.cookie.get(prefix + '_user_country') || ''
  }
}

function setUserInfo(params) {
  if (params.userId && params.accessToken && params.hour) {
    LS.cookie.set(prefix + '_userid', params.userId, params.hour);
    LS.cookie.set(prefix + '_token', params.accessToken, params.hour);
    LS.cookie.set(prefix + '_user_country', params.userCountry, params.hour);
  }
}

function delUserInfo() {
  LS.cookie.del(prefix + '_userid');
  LS.cookie.del(prefix + '_token');
  LS.cookie.del(prefix + '_user_country');
}



LS.user = {
  getUid: getUid,
  getSid: getSid,
  logIn: logIn,
  logOut: logOut,
  getInfo: getInfo,
  setUserInfo: setUserInfo,
  delUserInfo: delUserInfo
};


})(LookSKY);

;(function (LS) {

/*
 * md5
 */
var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase  */
var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance */
var chrsz = 8; /* bits per input character. 8 - ASCII; 16 - Unicode  */
/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_md5(s){ return binl2hex(core_md5(str2binl(s), s.length * chrsz));}
/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test() {
  return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << ((len) % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;
  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i+ 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
    d = md5_ff(d, a, b, c, x[i+ 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i+ 8], 7 , 1770035416);
    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i+12], 7 , 1804603682);
    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i+15], 22, 1236535329);
    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
    c = md5_gg(c, d, a, b, x[i+11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
    d = md5_gg(d, a, b, c, x[i+10], 9 , 38016083);
    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i+ 9], 5 , 568446438);
    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i+ 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
    c = md5_gg(c, d, a, b, x[i+ 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i+11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
    d = md5_hh(d, a, b, c, x[i+ 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i+13], 4 , 681279174);
    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i+ 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i+15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
    d = md5_ii(d, a, b, c, x[i+ 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i+12], 6 , 1700485571);
    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i+ 8], 6 , 1873313359);
    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i+13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i+ 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
}
function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}
/*
 * Convert a string to an array of little-endian words
 * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
 */
function str2binl(str) {
  var bin = Array();
  var mask = (1 << chrsz) - 1;
  for(var i = 0; i < str.length * chrsz; i += chrsz)
  bin[i>>5] |= (str.charCodeAt(i / chrsz) & mask) << (i%32);
  return bin;
}
/*
 * Convert an array of little-endian words to a hex string.
 */
function binl2hex(binarray) {
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var str = "";
  for(var i = 0; i < binarray.length * 4; i++)
  {
  str += hex_tab.charAt((binarray[i>>2] >> ((i%4)*8+4)) & 0xF) +
    hex_tab.charAt((binarray[i>>2] >> ((i%4)*8 )) & 0xF);
  }
  return str;
}

var userInfo = LS.user.getInfo();
var config = {
  shopId: LS.site.shop + '',
  accessToken: userInfo.token, // login token
  baseUrl: LS.env == 'production' ? 'https://global-api.westyleclub.com' : 'https://test.global-api.westyleclub.com',
  clientId: 'f8f6313700b286c96b0ffb180c456711', //客户端id
  signKey: '68efd4a39a55a6ab900857ac2c3f6611'  //签名key
};

var commonParams = {
  accessToken: config.accessToken, 
  clientId: config.clientId,
  appVersion: '1.0.0',
  channel: 'Web',
  platformType: 2,
  ulanguage: 'en',
  uSDKVersion: '1.0.0',
  stTimestamp: '',
  stSign: '',
  serverApiVersion: '1',
  shopId: config.shopId,
  clientFrom: 'H5', //客户端请求来源
  statTraceId: '0',
  currency: LS.site.currency,
  countryCode: LS.site.country,
  languageCode: LS.site.lang
};



function signParams(opts) {
  var strParams = '',
    ts = new Date().getTime();

  // 将 url 参数部分转为对象
  var str = opts.url.split('?')[1];
  var arr = str ? str.split('&') : [];
  var params = { stTimestamp: ts};
  for (var i = 0, l = arr.length; i < l; i++) {
    var kv = arr[i].split('=');
    params[kv[0]] = kv[1];
  }

  var keys = Object.keys(params).sort();
  for (var i = 0, l = keys.length; i < l; i++) {
    var k = keys[i];
    strParams += k + '=' + params[k] + '&';
  }

  if (opts.data) {
    strParams += JSON.stringify(opts.data) + '&key=' + config.signKey;
  } else {
    strParams += 'key=' + config.signKey;
  }

  commonParams.stSign = hex_md5(encodeURIComponent(strParams));
  commonParams.stTimestamp = ts;
  return commonParams;
}



function getHeaders(opts) {
  var sign = signParams(opts);
  var headers = {
    accessToken: config.accessToken,
    clientId: config.clientId,
    shopId: config.shopId,
    basicHeadParams: window.btoa(JSON.stringify(sign))
  };
  return headers;
}


/**
 * @method  ajax
 * @param {object}  配置参数，参考zepto，如果是调用非自研接口，则需要传递完整 url
 * @return
 * @example
  LS.ajax({
      url: '/getProductDetail',
      dataType:'json',
      data: {
          a: 1
      },
      success:function(results){
          //
      }
  });
  */
LS.ajax = function (opts) {
  if (!opts) return;
  // 测试环境切换正式环境，测试环境accessToken: test-94193821578c4f12aa091d920f174e20禁止请求正式环境接口
  if (LS.env == 'production' && config.accessToken.indexOf('test') >= 0) return;
  !opts.url.match(/^http/) &&  (opts.url = config.baseUrl + opts.url);
  opts.type = opts.type || 'get';

  (!!opts.data && opts.type == 'get') && (opts.url += (/\?/.test(opts.url) ? (/(&|\?)$/.test(opts.url) ? '' : '&') : '?') + $.param(opts.data));

  var defaultOpts = {
      timeout: 30000, // 默认30s超时
      withCredentials: 1, //让ajax支持cookie传递
      cache: false, //目前用的zepto版本 默认是true  这里Z.ajax默认为false   如果是调用$.ajax 还是默认true
      headers: opts.url.match(config.baseUrl) ? getHeaders(opts) : null,
      dataType: 'json', // 默认 json
  };

  $.extend(true, defaultOpts, opts);
  $.ajax(defaultOpts);
};


})(LookSKY);

;(function (LS) {


/**
 * @method loadUrl
 * @desc 异步加载一个外部静态资源, js或css
 * @param {string} url 需要加载的url
 * @param {string} callback 加载后回调
 * @param {string} charset  编码 默认是跟页面一致
 * @param {string} asyncType  defer、async
 * 
 */

//异步加载css或js
function loadUrl(url, callback, isCors, asyncType, charset) {

    var isCSS = /\.css(?:\?|#|$)/i.test(url);
    var node = document.createElement(isCSS ? "link" : "script")

    if (charset) {
        node.charset = charset;
    }


    node.onload = node.onerror = node.onreadystatechange = function() {
        if (/^(?:loaded|complete|undefined)$/.test(node.readyState)) {

            // Ensure only run once and handle memory leak in IE
            node.onload = node.onerror = node.onreadystatechange = null

            // Remove the script to reduce memory leak
            if (!isCSS) {
                document.body.removeChild(node)
            }

            // Dereference the node
            node = null

            callback && callback()
        }
    }

    if (isCSS) {
        node.rel = "stylesheet"
        node.href = url
    } else {
        if (asyncType) {
            node[asyncType] = asyncType
        }
        node.src = url;
        if (isCors) {//对于可支持跨域响应头的js 可以加这个 以便捕获详细错误
            node.crossorigin = "anonymous"
        }
    }

    document.body.appendChild(node);

}


LS.loadUrl = loadUrl;


})(LookSKY);


;(function (LS) {
/**
 * AB 测试通用接口，可以支持同时多个测试计划，每个计划可以支持任意给定分流策略进行分流
 *
 * @namespace LS.abt
 */



/**
 * 根据指定方案及占比进行分流
 * @param {Object} 方案对象
 * @param {Number} 运行次数
 * @return {Object} 返回各方案分流结果
 */
 function singleShunt(plan) {
  var names = [];  // 方案名
  var rates = [];  // 比率
  var ranges = [ 0 ]; // 累加区间范围
  var add = 0;     // 累积值
  for (var p in plan) {
    var r = plan[p];
    names.push(p);
    rates.push(r);
    add += r;
    ranges.push(add);
  }

  var rnd = Math.random();
  for (var i = 0, l = names.length; i < l; i++) {
    if (rnd >= ranges[i] / add && rnd < ranges[i + 1] / add) {
      break;
    }
  }

  return names[i];
}

/**
 * 对分流进行测试，可用于验证分流的准确性
 * @param {Object} 方案对象
 * @param {Number} 运行次数
 * @return {Object} 返回各方案分流结果
 * @example
 *  shuntTest({
      'a': 0.1,
      'b': 0.2,
      'c': 0.3,
      'd': 0.4
    }, 10000);

  返回： {
          a: {times: 1031, rate: 0.1031}
          b: {times: 1967, rate: 0.1967}
          c: {times: 2994, rate: 0.2994}
          d: {times: 4008, rate: 0.4008}
        }
 */
function shuntTest(plan, n) {
  var result = {};
  for (var i = 0; i < n; i++) {
    var name = singleShunt(plan);
    result[name] = (result[name] || 0) + 1;
  }

  for (var name in result) {
    var times = result[name]; // 命中次数
    var rate = times / n; // 占比
    result[name] = {
      times: times,
      rate: rate
    }
  }

  return result;
}

/**
 * 获取当前方案
 * @param {String} 类型，默认不传，如需返回字符串则需 type = 'string'
 * @return {Object|String} 返回当前方案结果
 */
function getPlan(type) {
  if (type == 'string') {
    return LS.cookie.get(storeKey) || '';
  }

  try {
    return JSON.parse(LS.cookie.get(storeKey) || 'null');
  } catch(e) {
    LS.reportJSError(e.message, 'module: abt');
    return null;
  }
}

/**
 * 批量分流：AB测试，会按制定测试计划和方案进行分流，支持多个测试计划，可多次调用
 * 简单得说，子域可以获取根域下的cookie, 但是根域无法获取子域下的cookie.
 * @param {Object} tests 测试计划对象 {'测试计划标识': { '方案1标识': 方案1占比, '方案2标识': 方案2占比}}
 * @return {Object} 返回当前分流结果
 * @example
 *  LS.abt.shunt({
      'also-like': {
        'a': 0.5,
        'b': 0.5
      },
      'buy-it-now': {
        'a': 10,
        'b': 30,
        'c': 20
      },
      'custom': {
        'a': 0.1,
        'b': 0.2,
        'c': 0.3,
        'd': 0.4
      }
    });
    返回：{also-like: 'a', buy-it-now: 'c', custom: 'b'}
 */
function shunt(tests) {
  var abt = getPlan() || {};
  var cflag = 0; // 改变标记

  for (var t in tests) {
    if (!abt[t]) { // 未分配过则分配
      abt[t] = singleShunt(tests[t]);
      cflag = 1;
    }
  }
  // 有变化则更新，每次设置则更新30天有效期，30天内没有任何ab测试cookie自动失效 
  cflag && LS.cookie.set(storeKey, JSON.stringify(abt), 24 * 30);
	LS.stat.config({ ab_flag: JSON.stringify(abt)});
  return abt;
}

/**
 * 初始化
 * @param {Array}，当前在运行中的计划列表 ['buy-it-now', 'also-like']
 * @return {Object|String} 返回当前方案结果
 */
 function init(plans = []) {
  var abt = getPlan() || {};
  var cflag = 0; // 改变标记
  
  // 清除历史分流计划, 仅保留当前计划
  for (var t in abt) {
    if (!plans.includes(t)) { // 不在当前实验列表则删除
      delete abt[t];
      cflag = 1;
    }
  }
  
  // 有变化则更新，每次设置则更新30天有效期，30天内没有任何ab测试cookie自动失效 
  cflag && LS.cookie.set(storeKey, JSON.stringify(abt), 24 * 30);
}

var storeKey = 'looksky-abt';

LS.abt = {
  init: init,
  shunt: shunt,
  getPlan: getPlan,
  shuntTest: shuntTest
};

})(LookSKY);


;(function (LS) {
	
/**
 * 简易js模板引擎
 * @namespace LS.tmpl
 * @desc 一个简单高性能js模板引擎，具有标签自定义、自动转义、支持字符串模板和html模板输入、字段编码（防止XSS）及容错等功能，并做了一些性能优化：去掉with；字符串拼接使用性能更好的字符串相加方式代替数组拼接方式；缓存编译函数结果。 语法说明：<% %> —— 包裹纯js代码; <%= %> —— 包裹js表达式并取值
 * 支持国际化翻译 <%t('key', data) %>
 * @example 
	模板字符串用法
		var html = LS.tmpl('<% var song = data.song || {};%><span data-id="<%=song.songid%>"><%-song.songname%></span>', data);
 */ 
	
	var fnCache = {},		// 编译函数缓存，避免重复编译
		options = {
			openTag : '<%',
			closeTag : '%>'
		};
	
	/**
	 * @method transfer
	 * @desc 字符串转义
	 * @param  {string} 字符串
	 * @return {string} 每位进行转义后的字符串
	 */
	function transfer(s) {
		s = (s || '') + '';
		var str = '';
		for (var i = 0, l = s.length; i < l; i++) {
			str += '\\' + s[i];
		}
		return str;
	}
		
	/**
	 * @method compile
	 * @desc 模板编译
	 * @param  {string} 模板字符串
	 * @param  {object} 可选对象 
	 * @return {function} 渲染函数 
	 */

	function compile(s, opt) {
		$.extend(options, opt);

		var fn = function() {},
			openTag = transfer(options.openTag),
			closeTag = transfer(options.closeTag),
			regOpen = new RegExp(openTag, 'g'),
			regClose = new RegExp(closeTag, 'g'),
			regEqual = new RegExp(openTag + '=(.*?)' + closeTag, 'g'),
			regTranslate = new RegExp(openTag + 't\\((.*?)\\)\\s*' + closeTag, 'g');

		fn = fnCache[s] || (fnCache[s] = new Function("data", "var str=`" + s
			.replace(/[\r\n\t]/g, " ")
			.replace(regTranslate, "`+LS.$t($1)+`")
			.replace(regEqual, "`+LS.encodeHTML(LS.decodeHTML($1+''))+`")
			.replace(regOpen, "`;")
			.replace(regClose, "str+=`")
			+ "`;return str;")
		);

		return fn;
	}
	
	/**
	 * @method render
	 * @desc 模板渲染
	 * @param  {string} 模板所在dom的id或者模板字符串
	 * @param  {object} 数据对象 
	 * @param  {object} 可选配置对象
	 * @return {string} 渲染后的html字符串 
	 */
	function render(s, data, opt) {
		try {
			return compile(s, opt)(data || {});
		} catch(e) {
      LS.reportJSError(e.message, 'module: tmpl');
      return '';
    }
	}
	
	
	LS.tmpl = render;

})(LookSKY);

/**
 * ready
 * @method ready
 * @desc 
 * @param {function}  cb 回调函数
 * @require zepto
 * 
 */
;(function() {

LS.ready = function (cb) {
    cb = cb || function () {};
	
	$(function() {
		cb();
	});
};

})();

;(function(LS) {

  var TRANSITION_END_EVENT = '';
  var BROWSER_PREFIX = '';
  // 浏览器兼容
  (function() {
    var e = document.createElement('fakeElement');
    var arr = [
      ['transition', 'transitionend', ''],
      ['WebkitTransition', 'webkitTransitionEnd', '-webkit-'],
      ['MozTransition', 'transitionend', '-moz-'],
      ['OTransition', 'oTransitionEnd', '-o-']
    ];

    for (var i = 0, l = arr.length; i < l; i++) {
      var b = arr[i];
      if (e.style[b[0]] !== undefined) {
        TRANSITION_END_EVENT = b[1];
        BROWSER_PREFIX = b[2];
        break;
      }
    }
  })();

  /**
   * 滑动切换类 Slider
   * 说明：该类定位是处理滑动相关行为，不做布局和样式部分功能，需要事先将所有滑块在 wrapper 内全部铺开，且 margin 需为0或不设置
   * @param {Object} options 参数
   * {
   *    {String} container 容器选择器
   *    {String} wrapper 包裹选择器，默认取 container 第一个子节点
   *    {String} slide 滑块选择器，默认取 wrapper 所有一级子节点
   *    {Boolean} isLoop 是否循环，默认 true
   *    {Boolean} isAuto 是否自动播放，默认取 wrapper 所有一级子节点
   *    {String} direction 方向，'x' - 横向，'y' - 纵向，默认 'x'
   *    {String} slideSpeed 滑动动画时长，默认 300ms
   *    {String} autoInter 自动滑动间隔时长，默认 3000ms
   *    {Function} endCallback 滑动结束回调，会传递 当前 slide 位置参数
   * }
   * @return {Object} 返回Slider实例对象
   * @example
   * var slider = new LS.Slider({ container: '.js_slider' });
   * slider.slideTo(1);
  */
  function Slider(options) {
    this.container = document.querySelector(options.container);
    if (!this.container) {
      return;
    }
    this.wrapper = options.wrapper ? this.container.querySelector(options.wrapper) : this.container.children[0];
    this.slides = options.slide ? this.wrapper.querySelectorAll(options.slide) : this.wrapper.children;

    this.isAuto = options.isAuto === undefined ? false : options.isAuto;
    this.isLoop = options.isLoop === undefined ? true : options.isLoop;
    this.slideSpeed = options.slideSpeed || 300;
    this.autoInter = options.autoInter || 3000;
    this.direction = options.direction || 'x';
    this.endCallback = options.endCallback || null;
  
    this.init();
  }
  

  
  Slider.prototype.init = function() {
    var startPos = { x: 0, y: 0 },
        startTime = 0,
        endTime = 0,
        posOffset = { x: 0, y: 0 },
        self = this;
    
        self.number = self.slides.length;
        self.copyNumber = 0;
        self.curIndex = 0;
        self.curPos = { x: 0, y: 0 };
        self.inter = null;

    if (self.number < 2) {
      return;
    }
  
    self.containerSize = self.direction == 'x' ? self.container.getBoundingClientRect().width : self.container.getBoundingClientRect().height;
    self.slideSize = self.direction == 'x' ? self.slides[0].getBoundingClientRect().width : self.slides[0].getBoundingClientRect().height;
    if (self.isLoop) { // 复制节点
      var numPerView = Math.ceil(self.containerSize / self.slideSize);
      self.copyNumber = self.number >= numPerView ? numPerView : 0;
  
      for (var i = 0; i < self.copyNumber; i++) {
        self.wrapper.appendChild(self.slides[i].cloneNode(true));
      }
  
      for (var i = 0; i < self.copyNumber; i++) {
        self.wrapper.insertBefore(self.slides[self.number - 1].cloneNode(true), self.wrapper.children[0]);
      }
    }
  
    self.slideTo(self.curIndex, 0);
    self.isAuto && self.startAuto();

    // 绑定事件
    self.wrapper.addEventListener('touchstart', function(e) {
      startTime = Date.now();
      var t = e.touches;
      if (t.length > 1) {
        return;
      }
      startPos = { x: t[0].pageX, y: t[0].pageY };
      posOffset = { x: 0, y: 0 };
      self.isAuto && self.stopAuto();
    });
    
    self.wrapper.addEventListener('touchmove', function(e) {
      var t = e.touches;
      if (t.length > 1) {
        return;
      }
      self.reset();
      posOffset = { x: t[0].pageX - startPos.x, y: t[0].pageY - startPos.y };
      var isMatch = self.direction == 'x' ? Math.abs(posOffset.x) > Math.abs(posOffset.y) : Math.abs(posOffset.x) < Math.abs(posOffset.y);
      if (isMatch) { // 滑动方向（通过位移大小确定）和设定方向匹配
        self.move({ x: self.curPos.x + posOffset.x, y: self.curPos.y + posOffset.y });
        e.cancelable && e.preventDefault();
      } else {
        startPos = { x: t[0].pageX, y: t[0].pageY };
      }
    });
    
    self.wrapper.addEventListener('touchend', function(e) {
      endTime = Date.now();
      var index = self.curIndex;
      var offset = self.direction == 'x' ? posOffset.x : posOffset.y;
      var isMatch = self.direction == 'x' ? Math.abs(posOffset.x) > Math.abs(posOffset.y) : Math.abs(posOffset.x) < Math.abs(posOffset.y);
      var speed = endTime - startTime;
      // 设定方向滑动位移大于非设定方向 并且 位移绝对值大于 1/4 滑动块大小或滑动很快时
      if (isMatch && (Math.abs(offset) > self.slideSize / 4 || Math.abs(offset) > 0 && speed < 300) ) {
        index = self.curIndex + (offset > 0 ? -1 : 1);
      }
      self.slideTo(index);
      self.isAuto && self.startAuto();
    });
  
    self.wrapper.addEventListener(TRANSITION_END_EVENT, function() {
      self.reset();
      typeof self.endCallback == 'function' && self.endCallback(self.curIndex);
    });

  };
  
  
  
  Slider.prototype.move = function (pos, duration) {
    var x = this.direction == 'x' ? pos.x : 0;
    var y = this.direction == 'y' ? pos.y : 0;
    this.wrapper.style[BROWSER_PREFIX + 'transform'] = 'translate3d(' + x + 'px, '+ y + 'px, 0px)';
    this.wrapper.style[BROWSER_PREFIX + 'transition-duration'] = (duration || 0) + 'ms';
  }
  
  Slider.prototype.slideTo = function(index, duration) {
    index = parseInt(index + '');
    var start = -1 * this.copyNumber;
    var end = this.number - 1 + this.copyNumber;
    if (index < start) {
      index = start;
    } else if (index > end) {
      index = end;
    }
    this.curIndex = index;
    var offset = -1 * (index + this.copyNumber) * this.slideSize;
    this.curPos = { x: this.direction == 'x' ? offset : 0, y: this.direction == 'y' ? offset : 0};
    this.move(this.curPos, duration === undefined ? this.slideSpeed : duration);
  };

  Slider.prototype.reset = function() {
    var index = this.curIndex;
    if (index >= this.number) {
      index = 0;
    } else if (index < 0) {
      index = this.number - 1;
    }
    index != this.curIndex && this.slideTo(index, 0);
  };
  
  Slider.prototype.slideNext = function() {
    this.slideTo(this.curIndex - 1);
  };
  
  Slider.prototype.slidePrev = function() {
    this.slideTo(this.curIndex + 1);
  };
  
  Slider.prototype.startAuto = function() {
    var self = this;
    self.isAuto && (self.inter = setInterval(function() {
      self.slideTo(self.curIndex + 1);
    }, self.autoInter));
  };
  
  Slider.prototype.stopAuto = function() {
    if (this.inter) {
      clearInterval(this.inter);
      this.inter = null;
    }
  };
  
  Slider.prototype.getIndex = function() {
    return this.curIndex;
  };
  
  
  
  
  LS.Slider = Slider;
  
  
})(LookSKY);


;(function (LS) {
/**
 * 监测接口，通过监测给定目标是否出现在可视区进行响应的处理（如图片懒加载，模块按需加载，曝光统计等）
 *
 * @namespace LS.observe
 */


/**
 * 初始化 IntersectionObserver 对象，做兼容处理
 * @param {Function} 回调
 */
function init(callback) {
  if (isInited) {
    callback();
    return;
  }

  if ('IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype,
        'isIntersecting', {
        get: function () {
          return this.intersectionRatio > 0;
        }
      });
    }
    isInited = true;
    callback();
    return;
  }

  var url = 'https://cdn.shopify.com/s/files/1/0594/1162/8204/t/131/assets/intersection-observer.js?v=18055088126202021722';
  LS.loadUrl(url, function() {
    isInited = true;
    callback();
  }, true);// 跨域加载

}


/**
 * 交叉监听及处理
 * @param {Object} targetElement：可见性区域被监控的元素element，此元素必须是根元素的后代 (如果根元素为视窗，则该元素必须被当前文档包含)。
 * @param {Function} callback： 可见性发生变化时触发的回调函数
 * @param {Object} options： 配置对象（可选，不传时会使用默认配置）
 * 详细参数参考：https://developer.mozilla.org/zh-CN/docs/Web/API/IntersectionObserver/IntersectionObserver
 */
function intersection(targetElement, callback, options) {
  init(function() {
    var observer = new IntersectionObserver(callback, options);
    observer.observe(targetElement);
  });
}


/**
 * 默认监测处理
 */
function initObserve() {
  intersection(
    document,
    function(entries, observer) {
     
    },
    {
      threshold : [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
    }
  );
}



var isInited = false;


LS.observe = {
  init: initObserve,
  intersection: intersection
};

})(LookSKY);
    
    
/**
 * 统计 
 */
;(function(LS) {

  /** 获取网络类型 */
  function getNetworkInfo() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || { };
    return [connection.effectiveType || '', connection.downlink || 0, connection.rtt || 0].join('|');
  }

  // 上报信息集合，部分字段通过后台获取 userAgent头部信息获取，不用上报
  var shopId = LS.site.shop + '';
  var prefix = LS.site.brand.toLowerCase();
  var eventData = {
    shop_id: shopId,
    platform: LS.platform, // 平台
    eid: '', // 事件id
    page_type: LS.site.page,
    uid: LS.user.getUid() || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx', // 用户id
    sid: LS.user.getSid() || 'sidxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx', // sessionId
    ab_flag: LS.abt.getPlan('string'), // ab测试当前命中的方案
    page_url: window.location.href, // 当前页面url
    customer_id: LS.cookie.get(prefix + '_userid') || '', // 已登录用户的ID，访客报空即可
    trace_id: '', // session_id
    test: LS.env == 'production' ? 0 : 1 , // 是否测试事件
    app_ver: '1.0.0', // app版本
    network: getNetworkInfo(), // 网络信息
    ts: 0, // 时间戳
    aid: 'empty', // 算法id
    country: LS.site.country, // 国家
    ch: LS.cookie.get('looksky-ch'), // 渠道
    info_3p: JSON.stringify({'fbc': LS.cookie.get('_fbc'), 'fbp': LS.cookie.get('_fbp'), 'ins': ''}),
    region: '0' // 地区
  };

  var userInfo = LS.user.getInfo();
 /**
   * 图片方式上报
   *
   * @param {Object} params 上报数据对象
   * 
   */
  function imgReport(params) {
    if (!params) {
      return;
    }

    var data = {
      token: userInfo.token,
      event: Object.assign({ }, eventData, params)
    };

    var img = new Image();
    img.onload = img.onerror = function () {
      img = null;
    };

    img.src = "https://data.westyleclub.com/collector/CollectV2?data=" + encodeURIComponent(JSON.stringify(data));
  }

  /**
   * 统计上报
   *
   * @param {Object} params 上报数据对象（单条）或数组（多条）
   * 
   */
  function send(params, callback, errCallBack) {
    if (!params) {
      return;
    }

    var data = {
      token: userInfo.token,
      event: []
    };
    var list = params.length > 0 ? params : [params];
    var events = [];
    var strData = '';

    for (var l = list.length, i = 0; i < l; i++) {
      eventData.ts = parseInt(Date.now() / 1000);
      events.push(Object.assign({ }, eventData, list[i]));
    }
    data.event = events;

    fetch('https://data.westyleclub.com/collector/BatchCollect', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(() => {
      callback && callback();
    }).catch(e => {
      errCallBack && errCallBack();
      imgReport({ eid: "js_error", ext1: e.message, ext2: 'looksky.js', ext3: 'LS.stat.send'});
      console.log(e.message);
    });
  }

  LS.stat = send;
  LS.stat.config = function(options) {
    Object.assign(eventData, options);

  };
  
})(LookSKY);

;(function() {


function pageReport(customEventData = {}) {
	// 页面曝光事件统一自动上报
	var doc = document;
	doc.addEventListener("DOMContentLoaded", function() {
		var obj = {
					eid: 'page_show',
					ext1: doc.referrer,
					ext3: doc.referrer ? LS.cookie.get('looksky-pagefrom') : 'none'
				}; 
		var el = LS.platform === 'H5' ? doc.querySelector('.js_stat_page_show') : doc.querySelector('.js_stat_page_show_pc');    
		if (el) {
			for (var i = 1; i < 10; i++) {
				var ext = $(el).find('.stat-ext' + i).text();
				ext && (obj['ext' + i] = JSON.stringify(JSON.parse(ext)));
			}
		}

		if (Object.keys(customEventData).length) {
			Object.assign(obj, customEventData);
		}

		LS.stat(obj);
	});

	// 统一点击劫持
	$(doc).on('click', function(e) {
		var el = e.target || e.srcElement;
		var click = el.getAttribute('stat-click');
		if (!!click) {
			return;
		}

		var obj = { eid: 'click' };
		for (var i = 1; i < 10; i++) {
			var ext = el.getAttribute('stat-ext' + i);
			ext && (obj['ext' + i] = ext);
		}

		obj['ext1'] && LS.stat(obj);
	});


	/**
	 * 图片曝光事件统一自动上报
	*/
	/*
	doc.addEventListener("load", function (e) {
		var el = e.target || e.srcElement;
		if (el.tagName.toLowerCase() == 'img') {
			var stag = el.getAttribute('stag-show') || '';
			if (!!stag) {
				// 上报，考虑批量上报
			}
		}
	});
	*/
}


function apiReport() {
	/**
	 * Ajax接口质量上报
	 * @method reportCode
	 * @param {object} opts 参数对象
	 * @example
			reportCode({
					url : 'Api的url',
					platform : "h5",		// 平台标识
					rate : 1,				// 采样率 例如 1/1000 则rate为1000
					type : 1,				// 1 成功；2 失败；3 逻辑失败
					code : 0,				// 后台返回码
					msg : '',				// 提示信息
					delay : 300,			// 'Api访问延时'
			});
	*/
	function reportCode(opts) {
		opts = opts || {};
		if(!opts.url || !opts.type || typeof opts.code == "undefined") {
				return;
		}

		opts.platform = opts.platform || 'H5';
		opts.rate = opts.rate || 1;
		opts.msg = encodeURIComponent(opts.msg || '');
		opts.delay = Math.round(opts.delay || 0);

		LS.stat({
			eid: 'api',
			ext1: opts.url,
			ext2: opts.platform, 
			ext3: opts.rate + '', 
			ext4: opts.type + '', 
			ext5: opts.code + '', 
			ext6: opts.msg,
			ext7: opts.delay + ''
		});
	};

	function initReport(event, xhr, opts) {
		if (opts.reportCode != false) {	// 设置 reportCode=false 时才不进行上报
			xhr.report = {
				startTime: event.timeStamp,
				url : opts.url,
				rate : 1,
				platform : opts.platform
			};
			opts.observeKeys && (xhr.report.observeKeys = opts.observeKeys);
		}
	}

	function hasEmptyProperty(obj, keys) {
		var emptyKeyList = [];
		if (Object.prototype.toString.call(keys) !== '[object Array]') return emptyKeyList;
		if (Object.prototype.toString.call(keys) === '[object Array]' && keys.length === 0) return emptyKeyList;
    for (var i = 0, len = keys.length; i < len; i++) {
			var obKey = keys[i];
			var properties = obKey.split('.');
      var res = obj;
			for (var prop of properties) {
				if (!res.hasOwnProperty(prop) || res[prop] === null || res[prop] === undefined) {
					emptyKeyList.push(obKey + ' is empty');
					break;
				} else {
					res = res[prop];
					if ((Object.prototype.toString.call(res) === '[object Array]' && res.length === 0 )|| Object.prototype.toString.call(res) === '[object Object]' && Object.keys(res).length === 0) {
						emptyKeyList.push(obKey + ' is empty');
					}
				}
			}
		}

    return emptyKeyList;
  }

	// 自动监听ajax请求进行返回码上报
	$(document).on("ajaxBeforeSend", function (event, xhr, opts) {
		initReport(event, xhr, opts);
	}).on("ajaxSend", function (event, xhr, opts) {// 兼容 jQuery 
		initReport(event, xhr, opts);
	}).on("ajaxSuccess", function (event, xhr, opts, data) {
		if (xhr && xhr.report) {
			if (data) {
				if (data.code == 1) {
					xhr.report.type = 2; 	// 失败
				} else {
					if (data.code == 0) {
            var observeKeys = opts.observeKeys;
            if (observeKeys) {
              var hasEmptyObserveKeys = hasEmptyProperty(data, observeKeys);
              if (hasEmptyObserveKeys.length) {
                xhr.report.type = 3;	// 失败
                xhr.report.code = -1;
                xhr.report.msg = hasEmptyObserveKeys.join(';');
								xhr.report.rate = 1; // 成功默认1/10采样
                return;
              }
            }
          }
					xhr.report.type = 1;
					xhr.report.rate = opts.reportRate || 10; // 成功默认1/10采样
				}

				xhr.report.code = data.error && data.error.code || 0;
				xhr.report.msg = data.error && data.error.message || '';
			} else {
					xhr.report.type = 2;	// 失败
					xhr.report.code = -1;
					xhr.report.msg = 'data is null';
			}
			xhr.report.delay = event.timeStamp - xhr.report.startTime;
		}
	}).on("ajaxError", function (event, xhr, opts, err) {
		if (xhr && xhr.report) {
				var errorCodeMap = {// 自定义error code映射
						'abort' : -601,			//请求中断
						'error' : -602,			//网络链接或服务端错误
						'parsererror' : -603,	//解析错误或4xx 5xx
						'timeout' : -604			//网络连接超时
				};
				xhr.report.type = 2;	// 失败
				xhr.report.code = (-xhr.status) || errorCodeMap[err] || -500;
				xhr.report.msg = 'server error';
				xhr.report.delay = event.timeStamp - xhr.report.startTime;
		}
	}).on("ajaxComplete", function (event, xhr, opts) {
		if (xhr && xhr.report) {
				if (xhr.report.rate == 1 || Math.random() < 1 / xhr.report.rate) {
						delete xhr.report.startTime;
						reportCode(xhr.report);
				}
		}
	});
}



function performanceReport() {
	// --------性能上报相关代码--------  
	window.addEventListener('load', function() {
		try {
		  var win = window,
		  pfTime = win.performance.timing,
		  onload = new Date();
	
		  LS.stat({
        eid: 'load_time',
        ext1: (pfTime.responseStart - pfTime.navigationStart) + '', // 首字节
        ext2: '', // 首屏 各页面根据实际业务场景自定义上报
        ext3: '', // 可交互 各页面根据实际业务场景自定义上报
        ext4: (pfTime.domainLookupEnd - pfTime.domainLookupStart) + '', // DNS
        ext5: (pfTime.connectEnd - pfTime.connectStart) + '', // TCP建立链接
        ext6: (pfTime.responseEnd - pfTime.responseStart) + '', // 页面传输耗时
        ext7: (pfTime.domContentLoadedEventEnd - pfTime.navigationStart) + '', // DomReady
        ext8: (onload - pfTime.navigationStart) + '' // onload
		  });
	
		} catch(e) {
		  imgReport && imgReport({ page_url: window.location.href, eid: "js_error", ext1: e.message, ext2: 'stat', ext3: 'load_time'});
      console.log(e.message);
		}
	});

}

function getChannel() {
	var ch = LS.getParam('ls_ch') || '';
	if (ch) {
		LS.cookie.set('looksky-ch', ch, 24);
		LS.stat.config({
			ch: ch
		})
	}
}



LS.init = function(config) {
	config = config || {};
	config.abt && LS.abt.init(config.abt);
	getChannel();
	pageReport(config.pageReport || {});
	apiReport();
	performanceReport();
};




})(LookSKY);